const localDate = (value) => {
  const [year, month, day] = String(value || '').split('-').map(Number);
  if (!year || !month || !day) return null;
  const date = new Date(year, month - 1, day);
  return Number.isNaN(date.getTime()) ? null : date;
};

const startOfDay = (value) => {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
};

const endOfDay = (value) => {
  const date = new Date(value);
  date.setHours(23, 59, 59, 999);
  return date;
};

export const transactionPeriodRange = (mode, selectedDate = '', now = new Date()) => {
  if (mode === 'all' || mode === 'range') return { dateFrom: '', dateTo: '' };

  if (mode === 'date') {
    const date = localDate(selectedDate);
    return date
      ? { dateFrom: startOfDay(date).toISOString(), dateTo: endOfDay(date).toISOString() }
      : { dateFrom: '', dateTo: '' };
  }

  const from = startOfDay(now);
  if (mode === 'week') {
    const daysSinceMonday = (from.getDay() + 6) % 7;
    from.setDate(from.getDate() - daysSinceMonday);
  } else if (mode === 'month') {
    from.setDate(1);
  }

  return { dateFrom: from.toISOString(), dateTo: endOfDay(now).toISOString() };
};

export const localDateBoundaryIso = (value, boundary) => {
  const date = localDate(value);
  if (!date) return '';
  return (boundary === 'end' ? endOfDay(date) : startOfDay(date)).toISOString();
};
